import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Bus, Cruise, Flights, Hotel, Train } from '../../assests/ExportImageIcon'

const TABS = [
    { key: 'flight', label: 'Flight', icon: Flights, path: '/home' },
    { key: 'train', label: 'Train', icon: Train, path: '/train' },
    { key: 'bus', label: 'Bus', icon: Bus, path: '/bus' },
    { key: 'hotel', label: 'Hotel', icon: Hotel, path: '/hotel' },
    { key: 'cruise', label: 'Cruise', icon: Cruise, path: '/cruise' },
]

const MainTab = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const active = TABS.find((tab) => tab.path === pathname)?.key

    return (
        <div className='mainTab'>
            {TABS.map((tab) => (
                <div
                    className={`tabInner ${active === tab.key ? 'active' : ''}`}
                    key={tab.key}
                    onClick={() => tab.path && navigate(tab.path)}
                >
                    <img src={tab.icon} alt={tab.label} />
                    {tab.label}
                </div>
            ))}
        </div>
    )
}

export default MainTab
